import React from 'react'
import NotFound from '../NotFound'


const NotFoundPage = () => {
    return (
        <NotFound />
    )
}

export default NotFoundPage


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/NotFoundPage.js